// extracted by mini-css-extract-plugin
module.exports = {"viewIcons":"styles_viewIcons__2eual","smHeader":"styles_smHeader__3dcRu","smBody":"styles_smBody__1mOgl"};